import Button from "@/components/ui/Button/Button";
import { Link } from "@/i18n/navigation";
import { useLocale, useTranslations } from "next-intl";

export default function PremiumCTA(props) {
    // Le nombre vient du parent quand il sait le lire sur le back ; sinon la
    // valeur figée de la configuration fait l'affaire.
    const nombreCommunaute =
        props.nombreComptes || Number(process.env.NUMBER_OF_STUDENTS);
    const t = useTranslations("PremiumCTA");
    const locale = useLocale();

    return (
        <>
            {/* Company logos */}
            <div className="flex justify-between items-center mt-20 mb-10 gap-4 lg:gap-4">
                <div className="flex-1 flex justify-center">
                    <img
                        src="/static/companies/google.webp"
                        alt="Google"
                        className="object-contain filter brightness-0 dark:brightness-100 h-[19px] lg:h-[25px]"
                    />
                </div>
                <div className="flex-1 flex justify-center">
                    <img
                        src="/static/companies/capgemini.webp"
                        alt="Capgemini"
                        className="object-contain filter brightness-0 dark:brightness-100 h-[19px] lg:h-[25px]"
                    />
                </div>
                <div className="flex-1 flex justify-center">
                    <img
                        src="/static/companies/deloitte.webp"
                        alt="Deloitte"
                        className="object-contain filter brightness-0 dark:brightness-100 h-[19px] lg:h-[25px]"
                    />
                </div>
                <div className="flex-1 hidden sm:flex sm:justify-center">
                    <img
                        src="/static/companies/amazon.webp"
                        alt="Amazon"
                        className="object-contain filter brightness-0 dark:brightness-100 h-[19px] lg:h-[25px]"
                    />
                </div>
                <div className="flex-1 hidden lg:flex lg:justify-center">
                    <img
                        src="/static/companies/ibm.webp"
                        alt="IBM"
                        className="object-contain filter brightness-0 dark:brightness-100 h-[19px] lg:h-[25px]"
                    />
                </div>
                <div className="flex-1 hidden xl:flex xl:justify-center">
                    <img
                        src="/static/companies/accenture.webp"
                        alt="Accenture"
                        className="object-contain filter brightness-0 dark:brightness-100 h-[19px] lg:h-[25px]"
                    />
                </div>
            </div>

            <section className="flex lg:flex-row flex-col items-center lg:gap-20 gap-10 mt-20 rounded-2xl bg-grayDark-900 lg:p-10 p-5">
                <div className="lg:w-2/3 w-full">
                    <h2 className="lg:text-3xl text-2xl font-bold leading-tight text-white font-sourceSans">
                        {t("title", {
                            numberOfStudents: Number(nombreCommunaute || 0).toLocaleString(locale),
                        })}
                    </h2>
                </div>
                <div className="lg:w-1/3 w-full flex flex-col gap-5">
                    <Link href="/pricing">
                        <Button type="primary" block>
                            {t("button.premium")}
                        </Button>
                    </Link>
                    <Link href="/teams">
                        <Button type="outline-secondary-dark" block>
                            {t("button.teams")}
                        </Button>
                    </Link>
                </div>
            </section>
        </>
    );
}
